import React from 'react'
import './Input.css'

const Input = ({ name, onChange, required, type, className, width, parentClassName, labelTop, value, disabled }) => {
    return (
        <>
            <p>{labelTop}</p>&nbsp;
            <div className={`rounded-md ${parentClassName || ''}`}>
                {type !== 'textarea' ?
                    <input style={{ width: `${width}px` }} required={required || false} disabled={disabled} value={value} type={type || 'text'} id={name} name={name} className={className || ''} onChange={onChange || null} />
                    :
                    <textarea style={{ width: `${width}px` }} required={required || false} disabled={disabled} value={value} type={type || 'text'} id={name} name={name} className={className || ''} cols="30" rows="7" onChange={onChange || null} />
                }
            </div>
        </>
    )
}

export default Input